import styled from "styled-components";


export const Container = styled.button`

    background: ${(props) => (props.whiteSchema ? "#f5f5f5" :" #0c0d0d")};
    color: ${(props) => (props.whiteSchema ? "#0c0d0d" : "#f5f5f5")};
    height: 45px;
    border-radius: 8px;
    border: 2px solid var(--black);
    font-family: 'Roboto Mono', monospace;
    margin-top: 16px;
    transition: 1s;
        :hover {
            border: 2px solid grey;
        }
    width: 100%;

`